module.exports = __webpack_public_path__ + "img/comparison-product-category.c2f8957e.png";